module.exports = __webpack_public_path__ + "img/background.a6f19aaa.png";